"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveAndDownload = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var buttons_1 = require("../buttons");
var Types_1 = require("./Types");
var Label_scss_1 = __importDefault(require("../labels/Label.scss"));
var SaveAndDownload = function (props) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('row', 'justify-content-center', 'mt-2', props.className), style: { display: props.onPrint || props.onSave ? undefined : 'none' } },
        react_1.default.createElement("div", { className: "col-auto" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(Label_scss_1.default['acs-dropdown-button'], 'btn-group') },
                props.onPrint && (react_1.default.createElement(buttons_1.Dropdown, { label: "Download" },
                    react_1.default.createElement(buttons_1.DropdownItem, { label: "PDF", onClick: function () {
                            props.onPrint && props.onPrint(Types_1.FileDownloadFormats.Pdf);
                        } }),
                    react_1.default.createElement(buttons_1.DropdownItem, { label: "MS Word", onClick: function () {
                            props.onPrint && props.onPrint(Types_1.FileDownloadFormats.Word);
                        } }),
                    props.additionalDownloadButtons)),
                !props.readOnly && props.onSave && (react_1.default.createElement(buttons_1.Dropdown, { className: "ml-3 mr-0", label: "Save", onClick: function () { return props.onSave && props.onSave(false); } },
                    react_1.default.createElement(buttons_1.DropdownItem, { label: "Save and Exit", onClick: function () {
                            props.onSave && props.onSave(true);
                        } })))))));
};
exports.SaveAndDownload = SaveAndDownload;
//# sourceMappingURL=SaveAndDownload.js.map